// extracted by mini-css-extract-plugin
export var separator = "vertical-spacing-small-module--separator--UsC3D";